import { gsap, ScrollTrigger, DrawSVGPlugin } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);


function animations() {
    // For animating svg's on program page
	if($('.first-program-svg').length) {
		gsap.from(".first-program-svg", {duration: 1, opacity: 0, x: -150}); //run first because its above trigger
		const svgs = gsap.utils.toArray('.program-svg');
		svgs.forEach(indivSvg => {
			gsap.from(indivSvg, {
				scrollTrigger: {
					trigger: indivSvg,
					start: "top bottom",
					toggleActions: "play none none none"
				}, 
				duration: 1, 
				opacity: 0, 
				x: -150
			});
		});
	};

	
	// Animating elements on front page hero
	if($('.anim-section').length) {
		var hptl = gsap.timeline();
		hptl.from("#line", {duration: 4, drawSVG:0, delay:0.5, stagger: 0.1})
		hptl.from(".anim-x", {duration: 1, opacity: 0, x: -150, stagger: 0.25}, "-=3");


		// Animate sections on homepage
		const section = gsap.utils.toArray('.anim-section');
		section.forEach(indivSection => {
			gsap.from(indivSection, {
				scrollTrigger: {
					trigger: indivSection,
					start: "bottom bottom",
					toggleActions: "play none none none"
				}, 
				duration: 1, 
				opacity: 0, 
				x: -150
			});
		});
	}
}

export { animations as default };